module.exports = __webpack_public_path__ + "./static/img/addNewCompany.cdceb5b31a720df69a1c71210aeff073.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/addNewCompany.png
// module id = ./client/src/assets/fontawesome/addNewCompany.png
// module chunks = 0